import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import UIButton from "../Button/Button";
import { styleType } from "../../../Constants/StyleType";
import UIModal from "../Modal/Modal";
import UIMultiselect from "../Multiselect/Multiselect";
import "./style.css";

function UIMultiselectModal(props) {
    const [modalOpen, setModalOpen] = useState(false);
    const [optionData, setOptionData] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        setOptionData(props.options);
    }, [props.options]);

    useEffect(() => {
        if (props.savedValue !== undefined && props.savedValue !== null) {
            const val = Array.isArray(props.savedValue)
                ? props.savedValue.join(",")
                : props.savedValue;
            if (val && val.toString().length > 0) {
                setSelectedKeys(val);
            }
        }
    }, [props.savedValue]);

    const onSearch = (e) => {
        let searchVal = e.target.value;
        if (!searchVal || searchVal.length === 0) {
            setOptionData(props.options);
        } else {
            let tmpData = structuredClone(props.options);
            if (props.options.length > 0 && typeof props.options[0] === "string") {
                setOptionData(tmpData.filter(x => x.includes(searchVal)));
            } else {
                setOptionData(tmpData.filter(x => x[props.displayKey].includes(searchVal)));
            }
        }
    };

    const onConfirm = () => {
        const value = document.getElementById(props.id + "val").value;
        setSelectedKeys(value);

        const count = value ? value.split(",").filter(v => v.trim() !== "").length : 0;
        if (props.onConfirm) {
            props.onConfirm(count);
        }

        setModalOpen(false);
    };

    const isSelected = selectedKeys && selectedKeys.length > 0;

    return (
        <>
            {/* Pre-populate hidden input so UIMultiselect can restore selections on open */}
            <input type="hidden" name={props.id} id={props.id} value={selectedKeys} />
            <UIButton
                onClick={() => { if (!props.disabled) setModalOpen(true); }}
                buttonText={props.title}
                styleType={isSelected ? styleType.PRIMARY : styleType.LIGHT}
                buttonType={"button"}
                additionalClass={"w-100 mt-2"}
                disabled={props.disabled}
            />

            <UIModal
                showModal={modalOpen}
                onConfirm={onConfirm}
                title={props.title}
                confirmButtonText={"OK"}
                body={<>
                    <input type="text" onChange={onSearch} className="form-control w-100 mb-2" placeholder="Search..." />
                    <UIMultiselect
                        id={props.id + "val"}
                        options={optionData}
                        displayKey={props.displayKey}
                        getKeyValue={props.id} />
                </>}
                withoutCloseBtn={true}
            />
        </>
    );
}

UIMultiselectModal.propTypes = {
    title: PropTypes.string,
    id: PropTypes.string,
    options: PropTypes.array,
    displayKey: PropTypes.string,
    onConfirm: PropTypes.func,
    disabled: PropTypes.bool,
    savedValue: PropTypes.any,
}

export default UIMultiselectModal;